<template>
  <div class="report-page">
    <el-card shadow="never" class="report-card">
      <div class="report-title">Yearly Maintenance Reporting</div>

      <div class="report-controls">
        <el-select
          v-model="selectedYearRange"
          size="mini"
          clearable
          placeholder="Select year range"
          class="year-filter"
        >
          <el-option
            v-for="item in yearRangeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>

        <el-button
          type="primary"
          icon="el-icon-download"
          :loading="exporting"
          @click="exportYearlyReport"
        >
          {{ exporting ? "Preparing Report..." : "Export PPM Yearly Report" }}
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { ppm } from "../../api/ppm/ppm";

export default Vue.extend({
  name: "ppm_yearly_export",
  data() {
    return {
      exporting: false,
      selectedYearRange: "2025-2026",
      yearRangeOptions: [
        { label: "2024-2025", value: "2024-2025" },
        { label: "2025-2026", value: "2025-2026" },
      ],
    };
  },
  methods: {
    async exportYearlyReport() {
    if (!this.selectedYearRange) {
      this.$message.error("Please select a year range.");
      return;
    }

    this.exporting = true;
    try {
      const response = await ppm.exportYearlyReport(
        this.$store.getters.getToken,
        this.$store.getters.getHost,
        this.selectedYearRange
      );

      if (!response.ok) {
        let errorMessage = `Export failed with status ${response.status}`;
        try {
          const payload = await response.json();
          if (payload && payload.error) {
            errorMessage = `${errorMessage}: ${payload.error}`;
          }
        } catch (_err) {
          const fallbackText = await response.text();
          if (fallbackText) {
            errorMessage = `${errorMessage}: ${fallbackText}`;
          }
        }
        throw new Error(errorMessage);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "PPM_Yearly_Report_" + this.selectedYearRange + ".xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      this.$message.success("PPM yearly report exported.");
    } catch (err) {
      console.log("Failed to export yearly report", err);
      const message = err instanceof Error ? err.message : "Failed to export PPM yearly report.";
      this.$message.error(message);
    } finally {
      this.exporting = false;
    }
    },
  },
});
</script>

<style scoped>
.report-page {
  padding: 24px;
  min-height: calc(100vh - 120px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.report-card {
  width: 100%;
  max-width: 680px;
  border-radius: 16px;
  border: 1px solid #d9e4ec;
}

.report-card ::v-deep .el-card__body {
  padding: 28px;
}

.report-title {
  font-size: 28px;
  font-weight: 700;
  color: #183247;
  margin-bottom: 20px;
}

.report-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

.year-filter {
  width: 220px;
}

@media (max-width: 768px) {
  .report-page {
    padding: 16px;
  }

  .report-title {
    font-size: 24px;
  }

  .report-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .year-filter {
    width: 100%;
  }
}
</style>
